var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7254 7.05822C13.4813 7.3023 13.4813 7.69803 13.7254 7.9421L15.1584 9.37516H8.33398C7.98881 9.37516 7.70898 9.65498 7.70898 10.0002C7.70898 10.3453 7.98881 10.6252 8.33398 10.6252H15.1584L13.7254 12.0582C13.4813 12.3023 13.4813 12.698 13.7254 12.9421C13.9695 13.1862 14.3652 13.1862 14.6093 12.9421L17.1093 10.4421C17.3533 10.198 17.3533 9.8023 17.1093 9.55822L14.6093 7.05822C14.3652 6.81414 13.9695 6.81414 13.7254 7.05822Z",
    fill: "#5F6366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 10.0002C3.33398 13.6821 6.31875 16.6668 10.0007 16.6668V13.5418C10.0007 12.7562 10.0007 12.3633 9.75657 12.1192C9.5125 11.8752 9.11966 11.8752 8.33398 11.8752C7.29845 11.8752 6.45898 11.0357 6.45898 10.0002C6.45898 8.96463 7.29845 8.12516 8.33398 8.12516C9.11966 8.12516 9.5125 8.12516 9.75657 7.88108C10.0007 7.63701 10.0007 7.24417 10.0007 6.4585V3.3335C6.31875 3.3335 3.33398 6.31826 3.33398 10.0002Z",
    fill: "#5F6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2e94f595c0caac3393ba0b8b54a40372.svg";
export { ForwardRef as ReactComponent };